import React from 'react'
import NavbarLayout from './NavbarLayout'
import SidebarLayout from './SidebarLayout'
import { Outlet } from 'react-router-dom'

type Props = {}

const PosScreenLayout = (props: Props) => {
  return (
    <React.Fragment>
      <NavbarLayout screen={"posScreen"} />
      <div className="flex h-[95vh]">
        <SidebarLayout screen={"posScreen"} />
        <div className="font-sans flex-grow overflow-y-auto p-4">
          <Outlet />
        </div>
      </div>
    </React.Fragment>
  )
}

export default PosScreenLayout